var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-mask" },
    [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          { staticClass: "scroll-box" },
          [
            _c(
              "v-container",
              { staticClass: "modal-container" },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      [
                        _c("h1", [_vm._v("Investimento")]),
                        _vm.loading
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "justify-center align-center"
                                  },
                                  [
                                    _c("v-progress-circular", {
                                      attrs: {
                                        size: 35,
                                        color: "primary",
                                        indeterminate: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-row",
                          { staticClass: "command-col" },
                          [
                            _c("v-col", [
                              _c(
                                "button",
                                {
                                  class: _vm.getSelfClass(),
                                  attrs: {
                                    type: "button",
                                    title:
                                      "Selecionar investimento para adição ao Kristal",
                                    disabled: _vm.loading
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selfStatus($event)
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.getSelfLabel()) + " ")]
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v("Nome: " + _vm._s(_vm.source.name))
                            ]),
                            _c(
                              "v-col",
                              {
                                staticClass: "item-editable",
                                attrs: {
                                  title:
                                    "Clique para editar o código do investimento"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.editCode($event)
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v("Código: " + _vm._s(_vm.source.code))
                                ])
                              ]
                            ),
                            _c("v-col", [
                              _vm._v("Isin: " + _vm._s(_vm.source.isin))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v("Status: " + _vm._s(_vm.source.status_imp))
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Mensagem: " + _vm._s(_vm.source.message_imp)
                              )
                            ]),
                            _c("v-col", [
                              _vm._v("Data: " + _vm._s(_vm.source.date_imp))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v("No.: " + _vm._s(_vm.source.number))
                            ]),
                            _c("v-col", [
                              _vm._v("Propr.: " + _vm._s(_vm.source.owner))
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Moeda: " + _vm._s(_vm.source.currencyCode)
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v("Tipo: " + _vm._s(_vm.source.type))
                            ]),
                            _c("v-col", [
                              _vm._v("Subt.: " + _vm._s(_vm.source.subtype))
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "T. últ. mês: " +
                                  _vm._s(
                                    _vm.percentageHelper.formatStandard(
                                      _vm.source.lastMonthRate
                                    )
                                  )
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v(
                                "T. anual: " +
                                  _vm._s(
                                    _vm.percentageHelper.formatStandard(
                                      _vm.source.annualRate
                                    )
                                  )
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Data: " +
                                  _vm._s(_vm.formatDate(_vm.source.date))
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Valor: " +
                                  _vm._s(
                                    _vm.currencyHelper.formatValue(
                                      _vm.source.value
                                    )
                                  )
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v(
                                "Quantidade: " + _vm._s(_vm.source.quantity)
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Total: " +
                                  _vm._s(
                                    _vm.currencyHelper.formatValue(
                                      _vm.source.amount
                                    )
                                  )
                              )
                            ]),
                            _c("v-col", [
                              _vm._v("Taxas: " + _vm._s(_vm.source.taxes))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v("Tx. adic.: " + _vm._s(_vm.source.taxes2))
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Saldo: " +
                                  _vm._s(
                                    _vm.currencyHelper.formatValue(
                                      _vm.source.balance
                                    )
                                  )
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Vencimento: " +
                                  _vm._s(_vm.formatDate(_vm.source.dueDate))
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v(
                                "Taxa: " +
                                  _vm._s(
                                    _vm.percentageHelper.formatStandard(
                                      _vm.source.rate
                                    )
                                  )
                              )
                            ]),
                            _c("v-col", [
                              _vm._v("Tp. Taxa: " + _vm._s(_vm.source.rateType))
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "T. fix. anual: " +
                                  _vm._s(
                                    _vm.percentageHelper.formatStandard(
                                      _vm.source.fixedAnnualRate
                                    )
                                  )
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v("Emissor: " + _vm._s(_vm.source.issuer))
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Emissão: " +
                                  _vm._s(_vm.formatDate(_vm.source.issueDate))
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Lucro: " + _vm._s(_vm.source.amountProfit)
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v(
                                "Saque: " +
                                  _vm._s(
                                    _vm.currencyHelper.formatValue(
                                      _vm.source.amountWithdrawal
                                    )
                                  )
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Original: " + _vm._s(_vm.source.amountOriginal)
                              )
                            ]),
                            _c("v-col", [
                              _vm._v("Status: " + _vm._s(_vm.source.status))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v(
                                "Nome b.: " +
                                  _vm._s(
                                    _vm.source.institution &&
                                      _vm.source.institution.name
                                  )
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "No. b.: " +
                                  _vm._s(
                                    _vm.source.institution &&
                                      _vm.source.institution.number
                                  )
                              )
                            ]),
                            _c("v-col", [_vm._v(" ")])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "data-table" },
                          [
                            _c("v-col", [
                              _vm.source.transactions &&
                              _vm.source.transactions.length
                                ? _c("table", [
                                    _c("caption", [_vm._v("Transações")]),
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [_vm._v("Negociação")]),
                                        _c("th", [_vm._v("Data")]),
                                        _c("th", [_vm._v("Total")]),
                                        _c("th", [_vm._v("Tipo")]),
                                        _c("th", [_vm._v("Marcada?")])
                                      ])
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.source.transactions, function(
                                        transaction
                                      ) {
                                        return _c(
                                          "tr",
                                          {
                                            key: transaction.transactionId,
                                            on: {
                                              click: function($event) {
                                                return _vm.viewTransaction(
                                                  transaction
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDateAbbr(
                                                    transaction.tradeDate
                                                  )
                                                )
                                              )
                                            ]),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDateAbbr(
                                                    transaction.date
                                                  )
                                                )
                                              )
                                            ]),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currencyHelper.formatValue(
                                                    transaction.amount
                                                  )
                                                )
                                              )
                                            ]),
                                            _c("td", [
                                              _vm._v(_vm._s(transaction.type))
                                            ]),
                                            _c("td", [
                                              _c("input", {
                                                attrs: {
                                                  type: "checkbox",
                                                  title:
                                                    "Status de seleção para adição ao Kristal",
                                                  disabled: _vm.loading
                                                },
                                                domProps: {
                                                  checked: transaction.import
                                                    ? "checked"
                                                    : ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.tgStatus(
                                                      $event,
                                                      transaction
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "v-btn",
        {
          staticClass: "close-btn",
          attrs: { icon: "", disabled: _vm.loading },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c("img", {
            staticClass: "icon",
            attrs: {
              src: require("@/assets/icons/close.svg"),
              alt: "dashboard"
            }
          })
        ]
      ),
      _vm.displaying
        ? _c("TransactionDetails", {
            attrs: { source: _vm.target },
            on: {
              close: function($event) {
                _vm.displaying = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }